module.exports = __webpack_public_path__ + "img/stop.8f3ab19e.png";